module.exports = __webpack_public_path__ + "static/media/iconM9.373ea569.svg";